export default __webpack_public_path__ + "media/images/react_icons/money_landlord-531c7db45c2a5f19b1d62ee0285a5736.svg";